import NoAudio from '@/constant/noAudio'
import { slideType } from '@/constant/allSlideTypes'
import Constant from '@/constant'
import { EXCLUDED_SLIDE_TYPES_FOR_IMPROVING_SLIDE_CONTENT } from '@/constant/slideTypes'

const { SLIDE_TYPE } = Constant

const PRESET_CONFIGURABLE_SLIDES = [
  SLIDE_TYPE.PICK_ANSWER,
  SLIDE_TYPE.IMAGE_CHOICE,
  SLIDE_TYPE.TYPE_ANSWER,
  SLIDE_TYPE.POLL,
  SLIDE_TYPE.WORD_CLOUD,
  SLIDE_TYPE.SCALE,
  SLIDE_TYPE.OPEN_ENDED,
  SLIDE_TYPE.IDEAS,
]

const FEATURE_TOGGLE_ENABLED = 'featureToggles/isFeatureEnabled'

// state
const _state = {
  isSlideTypeNoAudio: false,
}

// getters
const _getters = {
  isSlideTypeNoAudio: (_, __, rootState) => {
    const { slideTypes } = NoAudio
    return slideTypes.includes(rootState.slideActive.type)
  },

  isContentSlide: (_, __, rootState) => {
    return rootState.slideActive && rootState.slideActive.type === slideType.freeStyle
  },

  isExcludedSlideTypesForImprovingSlideContent: (_, __, rootState) => {
    const currentSlideType = rootState.slideActive && rootState.slideActive.type
    if (!currentSlideType) return false

    return EXCLUDED_SLIDE_TYPES_FOR_IMPROVING_SLIDE_CONTENT.includes(currentSlideType)
  },
  isPresetConfigurable(_, __, rootState) {
    return PRESET_CONFIGURABLE_SLIDES.includes(rootState.slideActive?.type)
  },
  canUseNewCreateSlidePopup: (_, __, rootState, rootGetters) => {
    // Google Slide integration runs a stripped-down editor that doesn't render
    // the new create-slide popup — force off so downstream consumers see the
    // legacy path regardless of the flag.
    if (rootState.integrationPlatform === 'GoogleSlide') return false
    return rootGetters[FEATURE_TOGGLE_ENABLED]('release-AHA-37354-new-create-slide-popup')
  },
  canUseSlideTypeDropdown(_, __, rootState, rootGetters) {
    if (rootState.integrationPlatform === 'GoogleSlide') return false
    const canUseNewPopup = rootGetters[FEATURE_TOGGLE_ENABLED]('release-AHA-37354-new-create-slide-popup')
    const canUseDropdown = rootGetters[FEATURE_TOGGLE_ENABLED]('release-AHA-39238-slide-type-dropdown')
    return canUseNewPopup && canUseDropdown
  },
  canUseSlideTypeDropdownHeader: (_, __, ___, rootGetters) => {
    return rootGetters[FEATURE_TOGGLE_ENABLED]('release-AHA-41434-slide-type-dropdown-header')
  },
  canUseCreateSlidePopupRecentlyUsedSection: (_, __, ___, rootGetters) => {
    return rootGetters[FEATURE_TOGGLE_ENABLED]('release-AHA-39233-create-slide-popup-recently-used-section')
  },
}

// mutations
const mutations = {
}

// actions
const actions = {
}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  mutations,
  actions,
}
